import idb from 'idb'

export default function dbPromise () {
  const dbPromise = idb.open('engineer-db', 5, upgradeDb => {
    switch (upgradeDb.oldVersion) {
      case 0:
        upgradeDb.createObjectStore('outbox', {
          autoIncrement: true
        })
        upgradeDb.createObjectStore('currentJob')
        upgradeDb.createObjectStore('imageStore')
        upgradeDb.createObjectStore('templates')
        // falls through
      case 1:
        upgradeDb.createObjectStore('jobStore')
        // falls through
      case 2:
        upgradeDb.createObjectStore('inProgressJobs', {
          autoIncrement: true
        })
        // falls through
      case 3:
        upgradeDb.createObjectStore('oldTemplates')
        // falls through
      case 4:
        upgradeDb.createObjectStore('fileDirLocation')
    }
  })

  return dbPromise
}



// WEBPACK FOOTER //
// ./src/dbPromise.js